import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";

const Wrapper = styled.h2`
  margin: ${({ theme }) => theme.spacer * 2}px
    ${({ theme }) => theme.spacer * 1.5}px;

  ${({ theme }) => theme.mediaQueries.medium} {
    margin: ${({ theme }) => theme.spacer * 2.5}px
      ${({ theme }) => theme.spacer * 4}px;
  }

  /* margin-bottom: 0; */
`;

const PageHeading = ({ className, children }) => {
  const classes = ["PageHeading"];
  if (className) classes.push(className);

  return <Wrapper className={classes.join(" ")}>{children}</Wrapper>;
};

PageHeading.displayName = "PageHeading";

PageHeading.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node.isRequired,
};

PageHeading.defaultProps = {
  className: null,
};

export default PageHeading;
